import { Language } from '../contexts/LanguageContext';

export const updateDocumentDirection = (isRTL: boolean) => {
  const html = document.documentElement;
  html.dir = isRTL ? 'rtl' : 'ltr';
  html.lang = isRTL ? 'he' : 'en';
};

export const getLanguageDirection = (language: Language): 'rtl' | 'ltr' => {
  return language === 'he' ? 'rtl' : 'ltr';
};

export const isRTL = (language: Language): boolean => {
  return language === 'he';
}; 